import script from "./posPage.vue?vue&type=script&setup=true&lang=js"
export * from "./posPage.vue?vue&type=script&setup=true&lang=js"

import "./posPage.vue?vue&type=style&index=0&id=c7823d28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7823d28"]])

export default __exports__